import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Pompiste } from '@/types';
import api from '@/api/client';
import { setPompistes, editPompiste, removePompiste } from '../slices/pompisteSlice';
import { setToast } from '../slices/toastSlice';

export const fetchPompistes = createAsyncThunk('pompiste/fetch', async (_, { dispatch, rejectWithValue }) => {
  try {
    const { data } = await api.get<{ data: Pompiste[] }>('/pompistes/');
    dispatch(setPompistes(data.data ?? []));
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Erreur chargement pompistes';
    dispatch(setToast({ message, severity: 'error' }));
    return rejectWithValue(message);
  }
});

export const createPompiste = createAsyncThunk<boolean, Partial<Pompiste>, { rejectValue: string }>(
  'pompiste/create',
  async (pompiste, { dispatch, rejectWithValue }) => {
    try {
      await api.post('/pompistes/', pompiste);
      await dispatch(fetchPompistes());
      dispatch(setToast({ message: 'Pompiste créé', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur création';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const updatePompiste = createAsyncThunk<boolean, Pompiste, { rejectValue: string }>(
  'pompiste/update',
  async (pompiste, { dispatch, rejectWithValue }) => {
    try {
      await api.put(`/pompistes/${pompiste.id}`, pompiste);
      dispatch(editPompiste(pompiste));
      dispatch(setToast({ message: 'Pompiste modifié', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur modification';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const deletePompiste = createAsyncThunk<boolean, Pompiste, { rejectValue: string }>(
  'pompiste/delete',
  async (pompiste, { dispatch, rejectWithValue }) => {
    try {
      await api.delete(`/pompistes/${pompiste.id}`);
      dispatch(removePompiste(pompiste));
      dispatch(setToast({ message: 'Pompiste supprimé', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur suppression';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);
